export default __webpack_public_path__ + "static/media/ioa-bg.bc6543a9.png";